<template>
	<div class="omapi-verify-site-change">
		<core-loading-button
			:loading="loading"
			:disabled="loading"
			:linkStyle="true"
			@click.prevent="handleVerification"
		>
			Click here
		</core-loading-button> to send a verification email to allow updating your <a :href="editSiteUrl" target="_blank" rel="noopener">{{ verifySiteName }} site</a> with this current domain.
		<div v-if="sent" class="omapi-verify-site-change omapi-verify-site-change-sent">
			<strong>Verification sent.</strong> Check your account email and click on the link to verify the site domain update. You will continue to see this notice until verification has been completed.
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	props : {
		siteData : {
			type : Object,
			default () {
				return {}
			},
		},
	},
	data () {
		return {
			loading : false,
			sent    : false,
		}
	},
	computed : {
		editSiteUrl () {
			return this.$get('siteData.editUrl', this.$urls.siteEditUrl())
		},
		verifySiteName () {
			let name = this.$get('siteData.name', 'registered OptinMonster')
			if (this.$get('siteData.domain')) {
				name += ` (${this.$get('siteData.domain')})`
			}

			return name
		},
	},
	methods : {
		...mapActions([ 'triggerSiteUpdateVerification' ]),
		handleVerification () {
			this.loading = true
			this.triggerSiteUpdateVerification()
				.then(() => {
					this.$emit('changeType', 'warn')
					this.sent = true
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>
<style lange="scsss" scoped>
	.omapi-verify-site-change {
		padding-top: 10px;
	}
</style>
